import React from 'react'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { postResetPassword } from '../../actions'
import ResetPasswordPresentation from '../../components/ResetPassword'

class ResetPassword extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    postResetPassword: PropTypes.func,
  }

  state = {
    email: '',
  }

  onChange = (email) => {
    this.setState({ email })
  }

  onSubmit = (event) => {
    event.preventDefault()
    this.props.postResetPassword(this.state.email)
    this.props.history.push(`/check-email`)
  }

  render() {
    return (
      <Page>
        <Title title="Reset your password" />
        <ResetPasswordPresentation
          onSubmit={this.onSubmit}
          onChange={this.onChange}
          value={this.state.email}
        />
      </Page>
    )
  }
}

const mapDispatch = (dispatch) => ({
  postResetPassword: (email) => dispatch(postResetPassword(email)),
})

export default withRouter(connect(null, mapDispatch)(ResetPassword))



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/ResetPassword/index.js